import React from "react";
import { GoArrowRight } from "react-icons/go";
const PrivacyPolicy = () => {
  return (
    <div className="maindiv">
      <h2>Privacy Policy</h2>
      <div className="termsandrivacydiv">
        <p>
          At Bhookr, your privacy is a priority. This Privacy Policy outlines
          how we collect, use, and protect your information when you visit our
          website or use our services.
        </p>
        <ul>
          <li>
            <span>
              <GoArrowRight className="text-[#de0101] mt-[5px] " />
            </span>

            <p>
              <p className="text-[#de0101] ">Information We Collect</p>
              <p>
                Advance Intimation for Pausing Meals Pausing or rescheduling
                meals requires at least one day’s notice. Requests made on the
                same day will not be accommodated, and the meal will be counted.
              </p>
              <p className="mt-[5px] ">
                Payment details to process transactions securely.
              </p>
              <p>Browsing data to enhance your user experience.</p>
            </p>
          </li>
          <li>
            <span className="text-[#de0101] mt-[5px] ">
              <GoArrowRight />
            </span>

            <p>
              <p className="text-[#de0101] "> How We Use Your Information</p>
              <p> To deliver your meals and manage subscriptions.</p>
              <p>To improve our services and customize your experience.</p>
              <p>To communicate updates, offers, and support.</p>
            </p>
          </li>
          <li>
            <span className="text-[#de0101] mt-[5px] ">
              <GoArrowRight />
            </span>

            <p>
              <p className="text-[#de0101]">Data Sharing</p>
              <p>We do not sell your personal information.</p>
              <p>
                Information is shared only with trusted partners for delivery,
                payment processing, or legal compliance.
              </p>
            </p>
          </li>
          <li>
            <span className="text-[#de0101] mt-[5px] ">
              <GoArrowRight />
            </span>

            <p>
              <p className="text-[#de0101]  "> Data Security</p>
              <p>Your data is protected with encryption and secure servers.</p>
              <p>
                We regularly update our systems to safeguard your information.
              </p>
            </p>
          </li>
          <li>
            <span className="text-[#de0101] mt-[5px] ">
              <GoArrowRight />
            </span>

            <p>
              <p className="text-[#de0101] ">Your Choices</p>
              <p>
                You can access, update, or delete your personal data by
                contacting us.
              </p>
              <p>Opt out of promotional communications at any time.</p>
            </p>
          </li>
          <li>
            <span className="text-[#de0101] mt-[5px] ">
              <GoArrowRight />
            </span>

            <p>
              <p className="text-[#de0101] "> Cookies</p>
              <p>
                Cookies are used to enhance website functionality and analyze
                site usage.
              </p>
              <p>
                You can manage cookie preferences through your browser settings.
              </p>
            </p>
          </li>
          <li>
            <span className="text-[#de0101] mt-[5px] ">
              <GoArrowRight />
            </span>

            <p>
              <p className="text-[#de0101] "> Policy Updates</p>
              <p>Changes to this policy will be posted on this page.</p>
              <p>
                Continued use of our website signifies your acceptance of any
                updates.
              </p>
              <p>
                For questions or concerns, contact us at{" "}
                <a href="mailto:bhookr555@gmail.com" id="privacymail">bhookr555@gmail.com</a>
              </p>
            </p>
          </li>
        </ul>

        <p className="text-[#de0101] my-[20px]">
          Thank you for trusting Bhookr!
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
